export default function Hero() {
  const avatars = [
    { key: 16, src: "https://public.readdy.ai/ai/img_res/9bcfb232512e16521ce9d08f8e97a076.jpg" },
    { key: 17, src: "https://static.readdy.ai/image/b5a48cb165ee6dba59bd8dc08534cd52/f6db840af9076ae9ccf0dbd2d23c5c6a.webp" },
    { key: 18, src: "https://static.readdy.ai/image/b5a48cb165ee6dba59bd8dc08534cd52/7fc410c8886ffe199473f88a9592e21b.png" },
    { key: 19, src: "https://static.readdy.ai/image/b5a48cb165ee6dba59bd8dc08534cd52/a4bb287f240343388de2cf8d0d491cdd.png" },
  ];

  return (
    <section className="relative min-h-[75vh] md:min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_887bb21e0abb664cf31f5a67054598c5_8430bd9e.jpg"
          alt="Dog owner walking in park"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/40 to-black/20"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-32">
        <div className="max-w-xl">
          <span className="inline-block bg-white/15 backdrop-blur-sm border border-white/30 text-white text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6 mt-10 md:mt-0">
            Trusted by 10,000+ Dog Owners
          </span>

          <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-4 md:mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            Walk Your Dog.<br />
            <span className="text-[#C4956A]">Skip the Mess.</span>
          </h1>

          <p className="text-white/85 text-base md:text-xl leading-relaxed mb-7 md:mb-10 max-w-md">
            The hygienic pooper scooper that keeps your hands clean and your walks stress-free — every single time.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 items-start">
            <a
              href="#product"
              className="bg-[#C4956A] hover:bg-[#b5845a] text-white font-bold text-base px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2 shadow-lg"
            >
              Get Yours — Only $18
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#how-it-works"
              className="border-2 border-white/60 hover:border-white text-white font-semibold text-base px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className="ri-play-circle-line"></i>
              See How It Works
            </a>
          </div>

          <div className="hidden md:flex items-center gap-6 mt-10">
            <div className="flex -space-x-2">
              {avatars.map(({ key, src }) => (
                <div key={key} className="w-9 h-9 rounded-full border-2 border-white overflow-hidden">
                  <img
                    src={src}
                    alt="Happy customer"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              ))}
            </div>
            <div>
              <div className="flex items-center gap-1 mb-0.5">
                {[1,2,3,4,5].map((s) => (
                  <i key={s} className="ri-star-fill text-[#C4956A] text-sm"></i>
                ))}
              </div>
              <p className="text-white/80 text-sm">4.9/5 from 2,400+ reviews</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-0 right-0 z-10 flex justify-center animate-bounce">
        <a href="#problem" className="flex flex-col items-center gap-1 cursor-pointer">
          <span className="text-white/60 text-xs uppercase tracking-widest">Scroll</span>
          <i className="ri-arrow-down-line text-white/60 text-lg"></i>
        </a>
      </div>
    </section>
  );
}
